import React, { useState } from "react";
import { UserOutlined } from '@ant-design/icons';
import { connect } from "react-redux";
import { Row, Col, Button, Space, Input,} from "antd";
import { getContactSearchResultbyPhone,} from "../../../../actions/contactAction";
import CreateNewContact from "./CreateNewContct";

const Demo = ({ getContactSearchResultbyPhone, bill, setCart, setContact }) => {
  const [showsuggetion, setshowsuggetion] = useState(false);
  const [contactsuggetions, setcontactsuggetions] = useState();
  const [contact, setcontact] = useState({});
  const [remove, setremove] = useState(false);
  const [searchPhone, setSearchPhone] = useState("");

  const [isModalVisible, setIsModalVisible] = useState(false);
  const handleModalCancel = () => {
    setIsModalVisible(false);
  };
  const handleModalOk = (values) => {
    console.log("Form values:", values);
    setIsModalVisible(false);
  };

  // Function to handle when a contact is selected/created
  const handleContactSelect = (selectedContact) => {
    setcontact(selectedContact);
    bill.current.Contact = selectedContact;
    setremove(true);
    if (setContact) {
      setContact(selectedContact);
    }
  };

  const onChange = (e) => {
    if (e.keyCode == 13) {
      getContactSearchResultbyPhone(e.target.value).then((result) => {
        setcontactsuggetions(result);
        setshowsuggetion(true);
        setSearchPhone(e.target.value);
      });
    }
    if (e.target.value == "") {
      setshowsuggetion(false);
    }
  };

  const renderContact = () => {
    if (showsuggetion) {
      return contactsuggetions.map((contact, index) => {
        if (contact.Type == "Customer" && index < 10) {
          return (
            <>
              <Row
                style={{
                  border: "1px solid lightgray",
                  padding: "5px",
                  marginBottom: "1px",
                  borderRadius: "5px",
                }}
                onClick={(e) => {
                  handleContactSelect(contact);
                  setshowsuggetion(false);
              }}
              >
                <Col span={16}>
                  <h4 style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                    {contact.phone}
                  </h4>
                </Col>
                <Col span={8}>{contact.name}</Col>
              </Row>
            </>
          );
        }
      });
    }
  };

  return (
    <>
      {remove ? (
        <Button
          onClick={(e) => {
            setremove(false);
            setcontact(null);
            bill.current.Contact = null;
            if (setCart) {
              setCart(true);
            }
            if (setContact) {
              setContact(null);
            }
          }}
          type="link"
          style={{color: "red"}}
        >
          Remove Contact
        </Button>
      ) : (
        <Space direction="Horizontal" style={{ width: "200%" }}>
          <Input
            prefix={<UserOutlined className="site-form-item-icon" />}
            placeholder="Enter Phone Number to select contact"
            onKeyUp={onChange}
            style={{ width: "150%" }}
          />
          <CreateNewContact 
            bill={bill} 
            setcontact={setcontact}
            setContact={setContact}
            onContactCreated={handleContactSelect}  // Pass the handler
            visible={isModalVisible}
            onCancel={handleModalCancel}
            onOk={handleModalOk}
            phone={searchPhone}
          />
        </Space>
      )}
      <div
        style={{
          position: "absolute",
          zIndex: "5",
          backgroundColor: "#F5F5F5",
          width: "100%",
        }}
      >
        {renderContact()}
      </div>
      <br></br>
      {contact ? (
        <>
          {contact.phone ? "Phone : " + contact.phone : ""}
        </>
      ) : (
        ""
      )}
    </>
  );
};
export default connect(null, {
  getContactSearchResultbyPhone,
})(Demo);